import { Route } from 'home/stack/types'
import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useThemeChange } from 'settings/change_theme'
import { TileBox } from '../tile_box'
import { RouteButton } from './route_button'

type Props = {
  routes: Route[]
  onButtonPress(route: Route, params?: object): void
}

export function ButtonBarTile({ routes, onButtonPress }: Props) {
  const { dark } = useThemeChange()
  return (
    <View style={styles(dark).container}>
      <TileBox>
        <View style={styles(dark).innerContainer}>
          {routes.map((route, index) => {
            return (
              <RouteButton
                key={index}
                route={route}
                onPress={() => onButtonPress(route)}
                darkMode={dark}
                badgeCountValue={route.badgeValue}
                disabled={route.disabled}
              />
            )
          })}
        </View>
      </TileBox>
    </View>
  )
}

export const styles = (darkMode: boolean) =>
  StyleSheet.create({
    container: { marginHorizontal: 16 },
    innerContainer: {
      height: 92,
      paddingHorizontal: 24,
      backgroundColor: darkMode ? '#353B4A' : '#FFFFFF',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  })
